<template>
  <div  v-show="showQrCode" class="qrCode">
		<div class="content">
			<div id="qrCode" class="qrCodeImg" ></div>
			<div class="text">手机扫码参与活动</div>
			<img @click="close()" class="close" src="@/assets/img/close.png" />
		</div>
  </div>
</template>


<script>
import { mapState } from 'vuex'
export default {
	name: 'qrCode',
	data(){
		return {
		}
	},
	mounted(){
		this.initQrcode();
	},
	created(){
		// this.show = this.store.state.showQrCode ;
	},
	watch : {
		qrCode(val){
			console.log('qrCode')
			console.log(val)
			this.qrcode.makeCode(val);
		}
	},
	computed: mapState([
		'init',
		'showQrCode',
		'qrCode'
	]),
	methods: {
		initQrcode(){
			this.qrcode = new QRCode(document.getElementById("qrCode"), {
				text: "test",
				colorDark : "#000000",
				colorLight : "#ffffff",
				correctLevel : QRCode.CorrectLevel.H
			});
		},
		close() {
			this.$store.commit('hideQrCode');
		}
	},
}
</script>

<style>
.qrCode{
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 5;
	background-color: rgb(0 0 0 / 42%);
}
.qrCode .content{
	width: 217px;
	height: 247px;
	padding: 10px 9px 0 8px;
	border: 2px solid #000000;
	border-radius: 10px;
	position: fixed;
	top: 50%;
	left: 50%;
	margin-top:  -123px;
	margin-left: -108px;
	background-color: #ffffff;
}
.qrCode .content .qrCodeImg{
	width: 200px;
	height: 191px;
}
.qrCode .content .qrCodeImg img{
	width: 100%;
}
.qrCode .content .text{
	margin: 6px 0 0 -8px;
	width: 217px;
	height: 40px;
	padding: 0 15px;
	font-size: 19px;
	color: #000000;
	text-align: justify;
	text-align-last: justify;
	word-break: break-all;
	text-justify: distribute;
	line-height: 40px;
}
.qrCode .close{
	width: 28px;
	margin: 10px auto 0;
	display: block;
}
</style>
